"use client";

/**
 * "Reserve a table" on the storefront — shown only when the house has tables.
 */

import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import type { Id } from "@/convex/_generated/dataModel";
import { Armchair } from "lucide-react";

export function ReserveTableButton({ brandId, className = "" }: { brandId: Id<"brands"> | string; className?: string }) {
  const setup = useQuery(api.foodBeverage.tables.getPublicSetup, { brandId: brandId as Id<"brands"> });
  if (!setup?.accepting) return null;
  return (
    <a
      href="/reserve"
      className={`inline-flex items-center gap-2 rounded-full bg-black px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-85 ${className}`}
    >
      <Armchair className="h-4 w-4" /> Reserve a table
    </a>
  );
}

export default ReserveTableButton;
